import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import i18n from "../i18n";

const AboutShark = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const tr = useMemo(() => {
    // langTick нужен, чтобы useMemo пересчитался при смене языка
    void langTick;

    return {
      title: i18n.t("about.title"),
      p1: i18n.t("about.p1"),
      p2: i18n.t("about.p2"),
      foundersLabel: i18n.t("about.foundersLabel"),
      founder1: i18n.t("about.founder1"),
      founder2: i18n.t("about.founder2"),
    };
  }, [langTick]);

  return (
    <div className="bg-gray-100 text-gray-700 py-16 px-6 md:px-12 lg:px-24">
      <motion.h1
        className="mt-12 max-w-6xl mx-auto text-left text-4xl font-bold mb-12 text-[#0A0A60]"
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: false }}
      >
        {tr.title}
      </motion.h1>

      <motion.p
        className="max-w-6xl mx-auto text-left text-lg leading-relaxed mb-6"
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}
        viewport={{ once: false }}
      >
        {tr.p1}
      </motion.p>

      <motion.p
        className="max-w-6xl mx-auto text-left text-lg leading-relaxed mb-6"
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: false }}
      >
        {tr.p2}
      </motion.p>

      <motion.div
        className="max-w-6xl mx-auto text-left mt-8 mb-12"
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}
        viewport={{ once: false }}
      >
        <p className="text-sm text-gray-700">{tr.foundersLabel}</p>
        <p className="text-base text-gray-700">{tr.founder1}</p>
        <p className="text-base text-gray-700">{tr.founder2}</p>
      </motion.div>
    </div>
  );
};

export default AboutShark;





